import { render } from "./scan.vue?vue&type=template&id=f6c133a6&scoped=true"
import script from "./scan.vue?vue&type=script&lang=js"
export * from "./scan.vue?vue&type=script&lang=js"

import "./scan.vue?vue&type=style&index=0&id=f6c133a6&lang=less&scoped=true"

import exportComponent from "D:\\workstudio\\website67\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c133a6"]])

export default __exports__